import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import drivername from "../../assets/71dfd03e2bc3d97ab6e9d15c83ddcf00.jpg";
import weblogo from "../../assets/weblogo.png";
import { FaEye, FaCalendarAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteBooking,
  fetchBooking,
  fetchDriver,
  updateTripStatus,
} from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/loader";
import ConfirmDialog from "../../components/deleteModal";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const BookingList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllBooking, setAllBooking] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState<boolean>(true);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllBooking);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500;
  const ITEMS_PER_PAGE = 10;
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [drivers, setDrivers] = useState<any[]>([]);
  const [selectedDriver, setSelectedDriver] = useState("");
  const [driverSearch, setDriverSearch] = useState("");
  const [driverPage, setDriverPage] = useState(1);
  const [driverTotalCount, setDriverTotalCount] = useState(0);
  const [driverLoading, setDriverLoading] = useState(false);
  const [showDriverDropdown, setShowDriverDropdown] = useState(false);
  const driverDropdownRef = React.useRef<HTMLDivElement>(null);
  const DRIVER_PAGE_SIZE = 20;
  const [dateFilter, setDateFilter] = useState({ startDate: "", endDate: "" });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = React.useRef<HTMLDivElement>(null);
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [getCurrentUser, setCurrentUser] = useState<any>(null);

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(
          fetchBooking(page, ITEMS_PER_PAGE, search, status, selectedDriver, dateFilter.startDate ? new Date(dateFilter.startDate + "T00:00:00").getTime() : undefined, dateFilter.endDate ? new Date(dateFilter.endDate + "T23:59:59").getTime() : undefined)
        );
        if (
          response &&
          response?.data &&
          response?.data?.data &&
          response?.data?.data?.length &&
          response?.isSuccess
        ) {
          setAllBooking(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
          setLoading(false);
        } else {
          setAllBooking([]);
          setTotalCount(0);
          setLoading(false);
        }
      } catch (error) {
        console.log(getAllBooking);
        setAllBooking([]);
        setTotalCount(0);
        setLoading(false);
      } finally {
        setIsLoading(false);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [search, page, dispatch, status, selectedDriver, dateFilter]);
  const gotoEdit = (id: string) => {
    navigate(`/edit-booking/${id}`);
  };
  useEffect(() => {
    const fetchUser = async () => {
        const userData = localStorage.getItem("user");
      if (userData) {
        setCurrentUser(JSON.parse(userData));
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const getAllDrivers = async () => {
      setDriverLoading(true);
      const response: any = await dispatch(fetchDriver(driverPage, DRIVER_PAGE_SIZE, driverSearch));
      if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
        if (driverPage === 1) {
          setDrivers(response?.data?.data);
        } else {
          setDrivers((prev) => [...prev, ...response?.data?.data]);
        }
        setDriverTotalCount(response?.data?.totalCount);
      } else if (driverPage === 1) {
        setDrivers([]);
        setDriverTotalCount(0);
      }
      setDriverLoading(false);
    };
    getAllDrivers();
  }, [dispatch, driverPage, driverSearch]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDriverPage(1);
    }, 400);
    return () => clearTimeout(handler);
  }, [driverSearch]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (driverDropdownRef.current && !driverDropdownRef.current.contains(e.target as Node)) {
        setShowDriverDropdown(false);
      }
      if (datePickerRef.current && !datePickerRef.current.contains(e.target as Node)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const gotoDetails = (id: string) => {
    navigate(`/view-Detail/${id}`);
  };

  const handleDeleteById = async (id: string) => {
    const response = await dispatch(deleteBooking(id));
    if (response && response.isSuccess) {
      const newBooking = getAllBooking.filter(
        (item: any) => item.activityLogId !== id
      );
      setAllBooking(newBooking);
    }
  };
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handleDeleteById(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToBooking = () => {
    navigate("/add-booking");
  };

  const  handleStatusUpdate = async (bookingId: any) => {
    try {
      const response: any = await dispatch(
        updateTripStatus(bookingId, "onGoing")
      );
      if (response?.isSuccess) {
        toast.success(response?.message);
         const newBooking = getAllBooking.filter(
        (item: any) => item.activityLogId !== bookingId
      );
      setAllBooking(newBooking);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error updating trip status:", error);
      alert("Something went wrong while updating.");
    }
  };
  return (
    <>
      <ToastContainer />
      <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 113px)", overflow: "hidden" }}>
        <div className="booking" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Trip Management
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Handle trips and schedules
              {getCurrentUser?.role === "superAdmin" ? (
                <span style={{ display: "block", marginTop: 6, fontSize: 13 }}>
                  One-time trips (created by admin drivers in the rider app) appear here with a &quot;One-time&quot; badge — only super admins see them in this list.
                </span>
              ) : null}
            </p>
          </div>
        {getCurrentUser && getCurrentUser.role !== 'schoolAdmin' && getCurrentUser.role !== 'superAdmin' && (
          <p>
            <button
              className="px-2 py-2"
              onClick={navigateToBooking}
              style={{
                background: "#2563EB",
                color: "#fff",
                borderRadius: "10px",
                height: "auto",
                width: "auto",
                border: "none",
                boxShadow: "none",
              }}
            >
              <AddIcon />
              Add New Booking
            </button>
          </p>
        )}
        </div>

      <Box sx={{ display: "flex", flexWrap:"wrap", justifyContent: "space-between", gap:"5px", alignItems: "center", mb: 2, px: "0px 16px 0px 0px", flexShrink: 0 }}>
        <TextField
          variant="outlined"
          placeholder="Search trips by name, driver, vehicle, etc..."
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            minWidth: 380,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "#fff",
              height: "40px",
              "& fieldset": { borderColor: "#d0d5dd" },
              "&:hover fieldset": { borderColor: "#7c6dff" },
              "&.Mui-focused fieldset": { borderColor: "#7c6dff" },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IoSearchOutline style={{ color: "#98a2b3", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <select
            onChange={(e: any) => setStatus(e.target.value)}
            style={{
              height: "40px",
              borderRadius: "10px",
              width: "150px",
              padding: "4px",
              border: "1px solid #d0d5dd",
              backgroundColor: "#fff",
              fontSize: "14px",
              color: "#344054",
              outline: "none",
            }}
          >
            <option value="">All Status</option>
            <option value="onGoing">Active</option>
            <option value="completed">Completed</option>
            <option value="yetToStart">In Progress</option>
            <option value="cancelled">Cancelled</option>
          </select>
          <Box ref={driverDropdownRef} sx={{ position: "relative" }}>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                height: "40px",
                borderRadius: "10px",
                width: "220px",
                border: "1px solid #d0d5dd",
                backgroundColor: "#fff",
                transition: "all 0.2s ease",
                "&:hover": { borderColor: "#7c6dff" },
                "&:focus-within": { borderColor: "#7c6dff", boxShadow: "0 0 0 3px rgba(124,109,255,0.1)" },
              }}
            >
              <IoSearchOutline style={{ position: "absolute", left: "10px", color: "#98a2b3", fontSize: 18, pointerEvents: "none" }} />
              <input
                type="text"
                placeholder="Search driver..."
                value={showDriverDropdown ? driverSearch : (drivers.find((d: any) => d._id === selectedDriver)?.driverName || "")}
                onFocus={() => setShowDriverDropdown(true)}
                onChange={(e) => setDriverSearch(e.target.value)}
                style={{
                  height: "100%",
                  width: "100%",
                  padding: "0 12px 0 36px",
                  border: "none",
                  borderRadius: "10px",
                  backgroundColor: "transparent",
                  fontSize: "14px",
                  color: "#344054",
                  outline: "none",
                }}
              />
              {(showDriverDropdown ? driverSearch : drivers.find((d: any) => d._id === selectedDriver)?.driverName) && (
                <Box
                  onClick={() => { setSelectedDriver(""); setDriverSearch(""); }}
                  sx={{
                    position: "absolute",
                    right: "8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    backgroundColor: "#e5e7eb",
                    "&:hover": { backgroundColor: "#d1d5db" },
                  }}
                >
                  <span style={{ fontSize: "12px", color: "#6b7280", lineHeight: 1 }}>x</span>
                </Box>
              )}
            </Box>
            {showDriverDropdown && (
              <Box
                sx={{
                  position: "absolute",
                  top: "46px",
                  left: 0,
                  right: 0,
                  maxHeight: "250px",
                  overflowY: "auto",
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  zIndex: 10,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1", borderRadius: "8px" },
                  "&::-webkit-scrollbar-thumb": { backgroundColor: "#c1c1c1", borderRadius: "8px" },
                  "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#a1a1a1" },
                }}
                onScroll={(e: any) => {
                  const { scrollTop, scrollHeight, clientHeight } = e.target;
                  if (scrollHeight - scrollTop <= clientHeight + 10 && !driverLoading && drivers.length < driverTotalCount) {
                    setDriverPage((prev) => prev + 1);
                  }
                }}
              >
                <Box
                  onClick={() => { setSelectedDriver(""); setDriverSearch(""); setShowDriverDropdown(false); }}
                  sx={{
                    px: 2, py: 1.2, cursor: "pointer", fontSize: "14px",
                    "&:hover": { backgroundColor: "#f0eeff" },
                    fontWeight: selectedDriver === "" ? 700 : 400,
                    color: selectedDriver === "" ? "#7c6dff" : "#344054",
                    borderBottom: "1px solid #f0f0f0",
                    transition: "all 0.15s ease",
                  }}
                >
                  All Drivers
                </Box>
                {drivers.map((driver: any) => (
                  <Box
                    key={driver._id}
                    onClick={() => { setSelectedDriver(driver._id); setDriverSearch(""); setShowDriverDropdown(false); }}
                    sx={{
                      px: 2, py: 1.2, cursor: "pointer", fontSize: "14px",
                      "&:hover": { backgroundColor: "#f0eeff" },
                      fontWeight: selectedDriver === driver._id ? 700 : 400,
                      color: selectedDriver === driver._id ? "#7c6dff" : "#344054",
                      borderBottom: "1px solid #f0f0f0",
                      transition: "all 0.15s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {selectedDriver === driver._id && (
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#7c6dff", flexShrink: 0 }} />
                    )}
                    {driver.driverName}
                  </Box>
                ))}
                {driverLoading && (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 1.5 }}>
                    <CircularProgress size={20} sx={{ color: "#7c6dff" }} />
                  </Box>
                )}
              </Box>
            )}
          </Box>
          <Box ref={datePickerRef} sx={{ position: "relative" }}>
            <IconButton
              onClick={() => setShowDatePicker(!showDatePicker)}
              sx={{
                height: "40px",
                width: "40px",
                border: "1px solid #d0d5dd",
                borderRadius: "10px",
                backgroundColor: "#fff",
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              <FaCalendarAlt style={{ color: dateFilter.startDate || dateFilter.endDate ? "#7c6dff" : "#98a2b3", fontSize: 18 }} />
            </IconButton>
            {showDatePicker && (
              <Box
                sx={{
                  position: "absolute",
                  top: "48px",
                  right: 0,
                  p: 2,
                  border: "1px solid #d0d5dd",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  zIndex: 10,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  minWidth: "220px",
                }}
              >
                <Typography variant="caption" sx={{ fontWeight: 600, color: "#344054" }}>Filter by Date</Typography>
                <Box>
                  <Typography variant="caption" sx={{ color: "#64748b" }}>Start Date</Typography>
                  <input
                    type="date"
                    value={dateFilter.startDate}
                    onChange={(e) => setDateFilter((prev) => ({ ...prev, startDate: e.target.value }))}
                    style={{
                      width: "100%",
                      height: "36px",
                      borderRadius: "8px",
                      border: "1px solid #d0d5dd",
                      padding: "4px 8px",
                      fontSize: "13px",
                      outline: "none",
                    }}
                  />
                </Box>
                <Box>
                  <Typography variant="caption" sx={{ color: "#64748b" }}>End Date</Typography>
                  <input
                    type="date"
                    value={dateFilter.endDate}
                    onChange={(e) => setDateFilter((prev) => ({ ...prev, endDate: e.target.value }))}
                    style={{
                      width: "100%",
                      height: "36px",
                      borderRadius: "8px",
                      border: "1px solid #d0d5dd",
                      padding: "4px 8px",
                      fontSize: "13px",
                      outline: "none",
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <button
                    onClick={() => { setDateFilter({ startDate: "", endDate: "" }); setShowDatePicker(false); }}
                    style={{
                      flex: 1,
                      height: "32px",
                      borderRadius: "8px",
                      border: "1px solid #d0d5dd",
                      backgroundColor: "#fff",
                      fontSize: "12px",
                      cursor: "pointer",
                      color: "#344054",
                    }}
                  >
                    Clear
                  </button>
                  <button
                    onClick={() => setShowDatePicker(false)}
                    style={{
                      flex: 1,
                      height: "32px",
                      borderRadius: "8px",
                      border: "none",
                      backgroundColor: "#7c6dff",
                      color: "#fff",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    Apply
                  </button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minHeight: 0 }}>
        <TableContainer className="responsive-table-wrapper" sx={{ flex: 1, overflowY: "auto" }}>
          <Table className="table tableforit">
            <TableHead className="th">
              <TableRow className="table-h-row">
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Trip Name
                  <FilterPopover column="tripName" filterType="text" currentValue={filters.tripName || ""} onFilterChange={setFilter} onClear={clearFilter} />
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Driver
                  <FilterPopover column="driver.driverName" filterType="text" currentValue={filters["driver.driverName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Route
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Start Time
                  <FilterPopover column="startTime" filterType="text" currentValue={filters.startTime || ""} onFilterChange={setFilter} onClear={clearFilter} />
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Passengers
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Status
                  <FilterPopover column="tripStatus" filterType="text" currentValue={filters.tripStatus || ""} onFilterChange={setFilter} onClear={clearFilter} />
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Date
                  <FilterPopover column="activityBookingCreatedOn" filterType="text" currentValue={filters.activityBookingCreatedOn || ""} onFilterChange={setFilter} onClear={clearFilter} />
                </TableCell>
                <TableCell
                  className="table-cell p-0"
                  style={{
                    backgroundColor: "#f9fafb",
                    color: "#6b7280",
                    fontWeight: 500,
                    fontSize: "18px",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {filteredData.map((booking: any, index) => (
                  <TableRow className="t-row" key={index}>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                        <span>{booking?.tripName || "--"}</span>
                        {booking?.isOneTimeTrip ? (
                          <Chip size="small" label="One-time" color="secondary" variant="outlined" />
                        ) : null}
                      </Box>
                    </TableCell>
                    {/* {booking.customer.map((customer: any) => (
                    <ul className="p-0 mt-4 text-black">
                      <li className="text-black">{customer.customerName || "--"}</li>
                    </ul>
                    )) || "--"} */}
                    <TableCell className="d-flex align-items-center">
                      <div style={{ height: "40px", width: "42px" }}>
                        <img
                          src={booking?.driver?.driverImage || weblogo}
                          onError={(e) => { (e.target as HTMLImageElement).src = weblogo; }}
                          style={{ objectFit: "cover" }}
                          className="rounded-circle w-100 h-100"
                        />
                      </div>
                      <Chip
                        label={booking?.driver?.driverName || "--"}
                        style={{
                          padding: "5px",
                          background: "#fff",
                          fontSize: ".875rem",
                        }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <span>
                        {booking?.startLocation?.streetAddress
                          ? String(booking.startLocation.streetAddress).slice(
                              0,
                              20
                            ) + "..."
                          : "--"}
                      </span>
                      <span style={{ marginLeft: "5px" }}>To</span>
                      <span style={{ marginLeft: "5px" }}>
                        {booking?.endLocation?.streetAddress
                          ? String(booking.endLocation.streetAddress).slice(
                              0,
                              20
                            ) + "..."
                          : "--"}
                      </span>
                    </TableCell>
                    <TableCell className="table-cel4">
                      {booking?.startTime
                        ? new Date(booking?.startTime).toLocaleTimeString(
                            "en-US",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            }
                          )
                        : "--"}
                    </TableCell>

                    <TableCell>{booking?.customer.length || 0}</TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {/* <select
                      value={booking.tripStatus}
                      style={{borderRadius:"30px",paddingTop:"10px",paddingBottom:"10px"}}
                      onChange={(e: any) => handleUpdateStatus(booking._id, e.target.value)}>
                      <option value="yetToStart">Active</option>
                      <option value="completed">Completed</option>
                      <option value="onGoing">In Progress</option>
                      <option value="cancelled">Schedule</option>
                                         </select> */}
                      {booking.tripStatus === "yetToStart" && (
                        <span
                          className="px-2 py-1 rounded-pill fw-semibold"
                          style={{
                            whiteSpace: "nowrap",
                            display: "inline-block",
                            backgroundColor: "#dbeafe",
                            color: "#1e40af",
                            fontSize: "0.75rem",
                          }}
                        >
                          In-Progress
                        </span>
                      )}

                      {booking.tripStatus === "onGoing" && (
                        <span
                          className="px-2 py-1 rounded-pill fw-semibold"
                          style={{
                              whiteSpace:"nowrap",
                            backgroundColor: "#d1fae5",
                            color: "#065f46",
                            fontSize: "0.75rem",
                          }}
                        >
                          Active
                        </span>
                      )}

                      {booking.tripStatus === "completed" && (
                        <span
                          className="px-2 py-1 rounded-pill fw-semibold"
                          style={{
                              whiteSpace:"nowrap",
                            backgroundColor: "#f3f4f6",
                            color: "#1f2937",
                            fontSize: "0.75rem",
                          }}
                        >
                          Completed
                        </span>
                      )}

                      {booking.tripStatus === "cancelled" && (
                        <span
                          className="px-2 py-1 rounded-pill fw-semibold"
                          style={{
                            whiteSpace:"nowrap",
                            backgroundColor: "#fecaca",
                            color: "#7f1d1d",
                            fontSize: "0.75rem",
                          }}
                        >
                          Cancelled
                        </span>
                      )}
                    </TableCell>

                    <TableCell>
                      {booking?.activityBookingCreatedOn
                        ? new Date(booking.activityBookingCreatedOn).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        : "--"}
                    </TableCell>

                    <TableCell>
                    {booking.tripStatus === "yetToStart" && (
                      <button className="changeStatusBtn"  onClick={() => handleStatusUpdate(booking.activityLogId)}>
                        {" "}
                        Trip Start{" "}
                      </button>
                    )}
                      <IconButton className="icon-btn">
                        <FaEye
                          style={{ color: "#0084ff" }}
                          onClick={() => gotoDetails(booking.activityLogId)}
                          className="icons"
                        />
                      </IconButton>
                                      {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (

                      <IconButton className="">
                        <EditIcon
                          style={{ color: "#0084ff" }}
                          onClick={() => gotoEdit(booking.activityLogId)}
                          className="icons"
                        />
                      </IconButton>
                                      )}
        {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (

                      <IconButton
                        onClick={() => handleDeleteClick(booking.activityLogId)}
                        className="icon-btn-red"
                        color="error"
                      >
                        <MdDelete className="icons " />
                      </IconButton>
                                                                            )}
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />

                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Booking Found.
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
            </TableBody>
          </Table>
        <nav>
          <ul className="pagination justify-content-center mt-3">
            <li className={`page-item ${page === 1 && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
              >
                Previous
              </button>
            </li>

            {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
              <li
                key={i + 1}
                className={`page-item ${page === i + 1 && "active"}`}
              >
                <button className="page-link" onClick={() => setPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li className={`page-item ${page === pageCount && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
        </TableContainer>

      </Paper>
      </div>
    </>
  );
};

export default BookingList;

